import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {ServicePointsEmptyStateProps} from './types';

const {title, description, action} = translations['pt-br'].privateFlow.help.ourAddresses.emptyState;

export function ServicePointsEmptyState({handleClearFilters}: ServicePointsEmptyStateProps) {
	return (
		<Stack gap={2} alignItems="center" mt={6}>
			<IconIllustration variant="default" customIconName="location-on-filled" width={80} />
			<Stack alignItems="center" gap={1}>
				<Typography variant="h6" textAlign="center" color="textPrimary">
					{title}
				</Typography>
				<Typography variant="body1" textAlign="center" color="textSecondary" width="75%">
					{description}
				</Typography>
			</Stack>
			<Button variant="outlined" onClick={handleClearFilters}>
				{action}
			</Button>
		</Stack>
	);
}
